const state = {
  infoStore:
    [
      {
        id: 1,
        title: "Three.js",
        version: "171",
        url: "https://github.com/mrdoob/three.js/releases"
      },
      {
        id: 2,
        title: "Orbit controls",
        version: "82.1.0",
        url: "https://threejs.org/docs/#examples/en/controls/OrbitControls"
      },
      {
        id: 3,
        title: "Vue.js",
        version: "3.5.13",
        url: "https://v3.ru.vuejs.org"
      },
      {
        id: 4,
        title: "Vue Router",
        version: "4.5.0",
        url: "https://router.vuejs.org"
      },
      {
        id: 5,
        title: "VueX",
        version: "4.1.0",
        url: "https://vuex.vuejs.org"
      },
      {
        id: 6,
        title: "Vue i18n",
        version: "9.9.1",
        url: "https://vue-i18n.intlify.dev"
      },
      {
        id: 7,
        title: "Webpack",
        version: "5.97.1",
        url: "https://webpack.js.org"
      },
      {
        id: 8,
        title: "HTML5",
        version: "",
        url: "https://developer.mozilla.org/ru/docs/Learn/HTML/Introduction_to_HTML"
      },
      {
        id: 9,
        title: "CSS3",
        version: "",
        url: "https://developer.mozilla.org/ru/docs/Learn/CSS/First_steps"
      },
      {
        id: 10,
        title: "FlexBox CSS",
        version: "",
        url: "https://developer.mozilla.org/ru/docs/Learn/CSS/CSS_layout/Flexbox"
      },
      {
        id: 11,
        title: "JavaScript",
        version: "",
        url: "https://developer.mozilla.org/ru/docs/Learn/JavaScript"
      },
      {
        id: 12,
        title: "TypeScript",
        version: "5.7.2",
        url: "https://www.typescriptlang.org/"
      },
      {
        id: 13,
        title: "Markdown",
        version: "",
        url: "https://www.markdownguide.org"
      },
      {
        id: 14,
        title: "Open Graph protocol",
        version: "",
        url: "https://ogp.me"
      },
      {
        id: 15,
        title: "Favicon",
        version: "",
        url: "https://developer.mozilla.org/en-US/docs/Glossary/Favicon"
      },
      {
        id: 16,
        title: "Sitemap",
        version: "",
        url: "https://www.sitemaps.org"
      },
      {
        id: 17,
        title: "Robots.txt",
        version: "",
        url: "https://developers.google.com/search/docs/crawling-indexing/robots/intro"
      },
    ]
};
const getters = {};
const mutations = {};
const actions = {};
export default {
  state,
  getters,
  mutations,
  actions
};